import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';

// Data table
import { Skeletonitems, SkeletonbodyTemplate, otherMasterTypes } from '../../../appconfig/Settings';

import { MasterTab } from '../MasterTab';
import { deleteDataWithParameters, getAllDetailsDirect, postAllData } from '../../../service/ProductService';
import { OTHERMASTER, UPDATE_OTHERMASTER } from '../../../config/ApiConstant';
import { AddOtherMasterValidate } from '../../../config/Validate';
import { OtherMasterColumns } from '../../../appconfig/DatatableSetting';
import { Dialog } from 'primereact/dialog';

export const OtherMaster = () => {
    document.title = 'Other Master | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [otherMasterData, setOtherMasterData] = useState<any>({});
    const [submitLoading, setSubmitLoading] = useState<boolean>(false);
    const [otherMasterList, setOtherMasterList] = useState<any>([]);
    const [errors, setErrors] = useState<any>({});
    const [editId, setEditId] = useState<any>(null);

    //delete
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const [deleteId, setDeleteId] = useState<any>(null);
    const [deleteLoader, setDeleteLoader] = useState<boolean>(false);

    // useEffect
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    useEffect(() => {
        getOtherMasterData();
    }, [otherMasterData?.masterList]);

    //onchange event
    const onInputChange = (e: any, name: string) => {
        let val;
        if (name === 'masterList') {
            val = e;
        } else {
            val = (e.target && e.target.value) || e.value || '';
        }
        setOtherMasterData({ ...otherMasterData, [name]: val });
    };

    // Add application bill master
    const addOtherMaster = async () => {
        try {
            const { errors, isError } = AddOtherMasterValidate(otherMasterData);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setSubmitLoading(true);

                let formData: any = new FormData();
                formData.append('DataCode', otherMasterData?.masterList?.code);
                formData.append('Data', otherMasterData?.new_entry);

                //API URL
                let apiUrl = OTHERMASTER;

                //Check Add/Edit then Put in Request
                if (!window.cn(editId)) {
                    formData.append('SrNo', editId);

                    apiUrl = UPDATE_OTHERMASTER;
                }

                const response = await postAllData(apiUrl, formData);
                if (response) {
                    setSubmitLoading(false);
                    setEditId(null);
                    setErrors({});
                    setOtherMasterData({
                        masterList: otherMasterData?.masterList,
                        new_enrty: ''
                    });
                    getOtherMasterData();

                    toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.data });
                }
            }
        } catch (error: any) {
            setPageLoad(true);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Get all application bills
    const getOtherMasterData = async () => {
        try {
            setPageLoad(false);
            const response = await getAllDetailsDirect(OTHERMASTER + '?DataCode=' + otherMasterData?.masterList?.code);

            //Check response
            if (response) {
                setOtherMasterList(response);
                setPageLoad(true);
            }
        } catch (error: any) {
            if (error.response) {
                setPageLoad(true);
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Sorry Could Not Load Data'
                });
            }
        }
    };

    // Template for action
    const actionsTemplate = (rowData: any) => {
        return (
            <>
                <div className="flex">
                    <Button icon="pi pi-pencil" tooltip="Edit" tooltipOptions={{ position: 'top' }} className="p-button-rounded" onClick={() => openEditModal(rowData)} />
                    <Button icon="pi pi-trash" tooltip="Delete" tooltipOptions={{ position: 'top' }} className="p-button-danger p-button-rounded ml-2" onClick={() => openDeleteModal(rowData?.SrNo)} />
                </div>
            </>
        );
    };

    //editDara
    const openEditModal = (rowData: any) => {
        setEditId(rowData?.SrNo);
        let dataList = otherMasterTypes.find((item: any) => item.code === rowData?.DataCode);
        setOtherMasterData({
            masterList: dataList,
            new_entry: rowData?.Data
        });
    };

    //Clear All Filter
    const clearAll = () => {
        setGlobalFieldFilter(null);
        setEditId(null);
        setErrors({});
        setOtherMasterData({});
    };

    // Open delete modal
    const openDeleteModal = (index: any) => {
        setDeleteId(index);
        setDeleteModal(true);
    };

    // Close delete modal
    const closeDeleteModal = () => {
        setDeleteId(null);
        setDeleteModal(false);
    };

    // Delete application
    const deleteApplication = async () => {
        try {
            setDeleteLoader(true);
            // Delete api call
            const response = await deleteDataWithParameters(OTHERMASTER + '?SrNo=' + deleteId);
            if (response) {
                setDeleteLoader(false);
                setDeleteModal(false);
                setDeleteId(null);
                toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: response?.data
                });
                setTimeout(() => {
                    getOtherMasterData();
                }, 1500);
            } else {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Something went wrong, Please try again.'
                });
                setDeleteLoader(false);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setDeleteLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    return (
        <>
            <MasterTab mainTabLabel="Other Master" />
            <Toast ref={toast} />
            <div className="card mt-4">
                <div className="p-fluid formgrid grid">
                    <div className="field col-12 md:col-6">
                        <label htmlFor="masterList">
                            Master Data List <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <Dropdown
                                value={otherMasterData?.masterList}
                                name="masterList"
                                options={otherMasterTypes}
                                filter
                                optionLabel="name"
                                placeholder="Select "
                                onChange={(e) => onInputChange(e.value, 'masterList')}
                                className={errors['masterList'] && 'p-invalid'}
                            />
                            <span className="focus-bg"></span>
                        </div>
                        <small className="p-invalid-txt">{errors['masterList']}</small>
                    </div>

                    <div className="field col-12 md:col-6">
                        <label htmlFor="new_entry">Add New Entry</label>
                        <div className="input-effect-div">
                            <InputText
                                value={!window.cn(otherMasterData?.new_entry) ? otherMasterData?.new_entry : ''}
                                name="new_entry"
                                autoComplete="off"
                                onChange={(e) => onInputChange(e, 'new_entry')}
                                className={errors['new_entry'] && 'p-invalid'}
                            />
                        </div>
                        <small className="p-invalid-txt">{errors['new_entry']}</small>
                    </div>
                </div>

                <div className="formgrid grid">
                    <div className="field col-12 md:col-12">
                        <div style={{ display: 'flex', float: 'right', gap: 4 }}>
                            <Button label="Clear" icon="pi pi-times" onClick={() => clearAll()} className="p-button-secondary mr-2" />
                            <Button label={!window.cn(editId) ? 'EDIT' : 'ADD'} icon="pi pi-check" onClick={() => addOtherMaster()} loading={submitLoading} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="card">
                {/* Datatable */}
                {pageLoad ? (
                    <>
                        <DataTable
                            value={otherMasterList}
                            showGridlines
                            stripedRows
                            globalFilter={globalFilter}
                            filters={globalFieldFilter}
                            onFilter={(e) => setGlobalFieldFilter(e.filters)}
                            className="datatable-responsive "
                            emptyMessage="No Data Found"
                        >
                            {OtherMasterColumns.map((col, i) => {
                                if (col.field === 'sr_no') {
                                    return <Column key={col.field} header={col.header} body={(_, { rowIndex }) => rowIndex + 1} style={{ minWidth: '5rem' }} />;
                                } else if (col.field === 'action') {
                                    return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                } else if (col.field === 'Data') {
                                    return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                } else {
                                    return <Column key={col.field} field={col.field} header={col.header} />;
                                }
                            })}
                        </DataTable>
                    </>
                ) : (
                    <>
                        {/* Skeleton Data table */}
                        <DataTable value={Skeletonitems}>
                            {OtherMasterColumns.map((col, i) => (
                                <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                            ))}
                        </DataTable>
                    </>
                )}
            </div>

            {/* Delete Dialog */}
            <Dialog
                visible={deleteModal}
                style={{ width: '450px' }}
                header="Delete Application"
                modal
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeDeleteModal} />
                        <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={deleteApplication} loading={deleteLoader} />
                    </>
                }
                onHide={closeDeleteModal}
            >
                <div className="flex align-items-center justify-content-start">
                    <i className="pi pi-exclamation-triangle mr-3 delete-triangle" style={{ fontSize: '2rem' }} />
                    <span className="delete-dialog-note">Note: Once you delete this Application, This will be deleted permentatly.</span>
                </div>
            </Dialog>
        </>
    );
};
